import { SURVEY_CREATE, SURVEY, REVISE } from "../constants/url";
import { message } from "antd";
import { catchErrors } from "../utils/catchErrors";
import { rawDataApiCall } from "../utils/servicesBaseUtil";
import { setLocalStorage } from "../utils/localStorage";

export const createSurveyApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return () => {
    let url = `${SURVEY_CREATE}`;

    rawDataApiCall({ url: url, method: "POST", data: data })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson);
          setLocalStorage("alrounderToken", responseJson?.data?.token);
        } else {
          message.error(responseJson?.message);
          failureCallback(responseJson?.data?.errors);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const updateSurveyApi = ({
  data,
  finalCallback,
  surveyId,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = `${SURVEY}/${surveyId}`;

    rawDataApiCall({ url: url, method: "POST", data: data })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson);
        } else {
          message.error(responseJson?.message);
          //   failureCallback(responseJson?.data?.errors);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const reviseSurveyApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = `${REVISE}`;

    rawDataApiCall({ url: url, method: "POST", data: data })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson);
        } else {
          message.error(responseJson?.message);
          failureCallback(responseJson?.data?.errors);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};
